// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__au1zu","field":"styles_field__Ct33M","fieldCol":"styles_fieldCol__1BrWk","diffCol":"styles_diffCol__3RQ5M","diff":"styles_diff__3TbDs"};